module.exports = __webpack_public_path__ + "img/ir.9023419.svg";